import React from "react";
import styles from "./styles.module.scss";
import spareImg from "../../../shared/images/spare.svg";

const TableLastFrame = (props) => {
  const { players, tableStyles, title = "" } = props;
  const squares = new Array(3).fill("");

  const findLastUp = (array) => {
    const temp = !(array.length % 2) ? array : [...array, ""];
    const last = temp.length > 6 ? temp.slice(temp.length - 6) : temp;

    return last.filter((val, index) => !(index % 2));
  };

  const findLastDown = (array) => {
    const temp = !(array.length % 2) ? array : [...array, ""];
    const last = temp.length > 6 ? temp.slice(temp.length - 6) : temp;
    return last.filter((val, index) => !!(index % 2));
  };

  const isSplit = (pin) => {
    return Math.floor(pin / 1024) === 1;
  };

  const someStyle = {
    "--evenBackground": tableStyles.evenRows.background,
    "--evenColor": tableStyles.evenRows.color,
    "--evenFontSize": tableStyles.evenRows.fontSize,
    "--evenFontWeight": tableStyles.evenRows.fontWeight,
    "--oddBackground": tableStyles.oddRows.background,
    "--oddColor": tableStyles.oddRows.color,
    "--oddFontSize": tableStyles.oddRows.fontSize,
    "--oddFontWeight": tableStyles.oddRows.fontWeight,
    "--scoreBackground": tableStyles.maxScore.background,
    "--scoreColor": tableStyles.maxScore.color,
    "--scoreFontSize": tableStyles.maxScore.fontSize,
    "--scoreFontWeight": tableStyles.maxScore.fontWeight,
    "--frameContainerBackground": tableStyles.frameContainer.background,
    "--frameContainerColor": tableStyles.frameContainer.color,
    "--frameContainerFontSize": tableStyles.frameContainer.fontSize,
    "--frameContainerFontWeight": tableStyles.frameContainer.fontWeight,
    "--sectionContainerBackground": tableStyles.sectionContainerBackground,
  };

  return (
    <div className={styles.containerTable} style={someStyle}>
      {title && <div className={styles.title}>{title}</div>}
      {players && players.length ? (
        <div className={`${styles.bodyTable} ${styles.tableLastFrame}`}>
          <div className={styles.headers} style={someStyle}>
            <span className={styles.header}>Player</span>
            <span className={styles.header}>Frame</span>
            {squares.map((e, index) => (
              <span className={styles.header} key={index}></span>
            ))}
            <span className={styles.header} style={someStyle}>
              Max Score
            </span>
          </div>
          {players.map((laneThrow, ind) => {
            const lastThrowUp = findLastUp(laneThrow.throws);
            const lastThrowDown = findLastDown(laneThrow.throws);
            const lastPinsUp = findLastUp(laneThrow.pins);
            const lastPinsDown = findLastDown(laneThrow.pins);
            return (
              <div className={styles.players} key={ind} style={someStyle}>
                <div className={styles.squares}>
                  <span className={`${styles.square}`} style={someStyle}>
                    {laneThrow.displayName}
                  </span>
                  <span className={`${styles.square}`} style={someStyle}>
                    {Math.round(((laneThrow.throws.length || 0) + 1) / 2) || 1}
                  </span>
                  {squares.map((e, index) => (
                    <span
                      className={`${styles.square} ${styles.active} ${
                        laneThrow.throws &&
                        laneThrow.throws.length > index * 2 &&
                        styles.past
                      }`}
                      key={index}
                      style={someStyle}
                    >
                      {(lastThrowUp &&
                        lastThrowUp.length &&
                        lastThrowUp[index] !== "X" &&
                        index < 9 && (
                          <span className={styles.numbers}>
                            <span
                              className={`${styles.number} ${
                                isSplit(lastPinsUp[index]) && styles.split
                              }`}
                            >
                              {lastThrowUp &&
                                lastThrowUp.length &&
                                lastThrowUp[index]}
                            </span>
                            {lastThrowDown &&
                              lastThrowDown.length &&
                              lastThrowDown[index] !== "/" && (
                                <span
                                  className={`${styles.number} ${
                                    isSplit(lastPinsDown[index]) && styles.split
                                  }`}
                                >
                                  {lastThrowDown[index]}
                                </span>
                              )}
                            {lastThrowDown &&
                              lastThrowDown.length &&
                              lastThrowDown[index] === "/" && (
                                <span className={styles.number}>
                                  <img src={spareImg} alt="" />
                                </span>
                              )}
                          </span>
                        )) ||
                        ""}
                      {(lastThrowUp &&
                        lastThrowUp.length &&
                        lastThrowUp[index] === "X" && (
                          <span className={styles.strike}>X</span>
                        )) ||
                        ""}
                    </span>
                  ))}
                  <span className={styles.square} style={someStyle}>
                    {!props.showLow && laneThrow.maxScore}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div>There are no players</div>
      )}
    </div>
  );
};

export default TableLastFrame;
